import PartnerSchoolIcon from '@material-ui/icons/ViewList';

export default {
  // list: CustomerList,
  // create: CustomerCreate,
  // edit: CustomerEdit,
  icon: PartnerSchoolIcon,
};
